import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import styles from './index.module.scss';

type PropsWithStyles<T> = T & {
  style?: CSSProperties;
  className?: string;
};

export interface DashboardCardProps {
  title?: ReactNode;
  extra?: ReactNode;
}

export const DashboardCard: FC<PropsWithStyles<DashboardCardProps>> = (props) => {
  const { title, extra } = props;

  return (
    <div className={classNames(styles.dashboardCard, props.className)} style={props.style}>
      <div className={styles.dashboardCardHeader}>
        {title && <div className={styles.dashboardCardTitle}>{title}</div>}
        {extra && <div className={styles.dashboardCardExtra}>{extra}</div>}
      </div>
      {props.children && <div>{props.children}</div>}
    </div>
  );
};
